(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function() {
    function initAccountPanel() {
      const panel = document.getElementById('account-panel');
      const trigger = document.querySelector('.header-account-trigger');
      
      if (!panel || !trigger) return;

      let activeElement = null;

      function openPanel() {
        activeElement = document.activeElement;
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');

        const closeButton = panel.querySelector('.account-panel__close');
        const focusElement = closeButton || panel.querySelector('.account-panel__item');
        if (typeof trapFocus === 'function' && focusElement) {
          trapFocus(panel, focusElement);
        }
      }

      function closePanel() {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(activeElement);
        }
      }

      trigger.addEventListener('click', openPanel);
      
      const closeButton = panel.querySelector('.account-panel__close');
      const backdrop = panel.querySelector('.account-panel__backdrop');
      const container = panel.querySelector('.account-panel__container');
      
      if (closeButton) {
        closeButton.addEventListener('click', closePanel);
      }
      
      // Close on backdrop click - backdrop is behind container, so clicks on backdrop will close
      if (backdrop) {
        backdrop.addEventListener('click', function(e) {
          closePanel();
        });
      }
      
      // Close on click outside container - handle clicks on panel that are not on container or its interactive children
      panel.addEventListener('click', function(e) {
        // If click is directly on backdrop, it's already handled above
        if (e.target === backdrop) {
          return;
        }
        
        // If click is outside container (on backdrop area), close panel
        // Don't close if clicking on interactive elements (links, buttons)
        if (container && !container.contains(e.target) && !e.target.closest('a[data-account-overlay-link]') && !e.target.closest('button')) {
          closePanel();
        }
      });
      
      // Also handle clicks on container background (empty areas) - close if clicking on container itself
      if (container) {
        container.addEventListener('click', function(e) {
          // If clicking directly on container element itself (not on any child), close panel
          // This handles clicks on empty space within the container background
          if (e.target === container) {
            closePanel();
          }
        });
      }
      
      const accountLinks = panel.querySelectorAll('a[data-account-overlay-link]');
      if (accountLinks.length > 0) {
        accountLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            const href = link.getAttribute('href');
            
            // For other links, use standard behavior
            if (href && href !== '#' && !href.startsWith('javascript:')) {
              // Close panel after a short delay to allow navigation to start
              setTimeout(function() {
                closePanel();
              }, 100);
            } else {
              // If href is invalid, prevent default to avoid page refresh
              e.preventDefault();
            }
          });
        });
      }

      panel.addEventListener('keyup', function(evt) {
        if (evt.code === 'Escape') closePanel();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccountPanel);
    } else {
      initAccountPanel();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
